import { Component, OnInit } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { AnnouncementQuery } from 'src/app/services/announcement/announcement.query';
import { AnnouncementService } from 'src/app/services/announcement/announcement.service';
import { AnnouncementModel } from 'src/app/services/dto/announcement.model';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss'],
})
export class NewsComponent  implements OnInit {
  announcements:AnnouncementModel[] = []
  constructor(public announcementService:AnnouncementService) { }

  ngOnInit() {
    this.announcementService.fetchAnnouncements().then((announcement:AnnouncementModel[]) => {
      this.announcements = announcement     
    })
  }

}
